module.exports = __webpack_public_path__ + "assets/img/f55fffb2fa769b21b0e3780b047820a3.svg";